/**
 * Fixed Plans Data Structure
 * These plans are defined in code (hardcoded) since they are fixed offerings.
 * Prices and discounts are managed separately in the database.
 */

export interface PlanData {
  code: 'free' | 'group' | 'unlimited';
  name: string;
  description: string;
  period: string;
  features: string[];
  disabled: string[];
  highlight: boolean;
}

export const PLANS: Record<string, PlanData> = {
  free: {
    code: 'free',
    name: 'Free',
    description: 'Perfeito para músicos individuais que querem experimentar.',
    period: 'para sempre',
    features: [
      '1 usuário',
      'Até 10 músicas salvas',
      'Transposição automática',
    ],
    disabled: ['Colaboração em tempo real', 'Compartilhamento de grupo'],
    highlight: false,
  },
  group: {
    code: 'group',
    name: 'Group',
    description: 'Ideal para grupos de louvor e bandas pequenas.',
    period: 'por mês',
    features: [
      'Até 5 usuários',
      'Até 50 músicas salvas',
      'Colaboração em tempo real',
      'Avisos ao vivo (líder/seguidor)',
      'Compartilhamento de grupo',
    ],
    disabled: ['Usuários ilimitados', 'Músicas ilimitadas'],
    highlight: true,
  },
  unlimited: {
    code: 'unlimited',
    name: 'Unlimited',
    description: 'Para igrejas e ministérios sem limites.',
    period: 'por mês',
    features: [
      'Usuários ilimitados',
      'Músicas ilimitadas',
      'Colaboração em tempo real',
      'Todos os avisos ao vivo',
      'Suporte prioritário',
      'API de integração',
    ],
    disabled: [],
    highlight: false,
  },
};

export const getPlanData = (code: string): PlanData | null => {
  return PLANS[code as keyof typeof PLANS] || null;
};
